import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ExecutiveBoard.scss";

const PLACEHOLDER =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23cccccc' viewBox='0 0 24 24'%3E%3Cpath d='M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 7C14.5 7 14 7.5 14 8V10C14 10.5 14.5 11 15 11L17 11V21C17 21.5 17.5 22 18 22H20C20.5 22 21 21.5 21 21V9ZM3 9V7L9 7C9.5 7 10 7.5 10 8V10C10 10.5 9.5 11 9 11L7 11V21C7 21.5 6.5 22 6 22H4C3.5 22 3 21.5 3 21V9Z'/%3E%3C/svg%3E";

const ExecutiveBoard = () => {
    const [boardMembers, setBoardMembers] = useState([]);

    useEffect(() => {
        const fetchBoard = async () => {
            try {
                const response = await axios.get('/api/executive-board/');
                const data = Array.isArray(response.data) ? response.data : response.data.results || [];
                setBoardMembers(data);
            } catch (error) {
                console.error('Error fetching executive board:', error);
            }
        };
        fetchBoard();
    }, []);

    return (
        <div className="executive-board">
            <div className="executive-board__header">
                <h1>2026-2027 Ladies Guild Executive Board</h1>
                <p>Meet the dedicated women who lead our Ladies Guild</p>
            </div>

            <div className="executive-board__grid">
                {boardMembers.map((member) => (
                    <div key={member.id} className="board-member">
                        <div className="board-member__photo">
                            <img
                                src={member.photo || PLACEHOLDER}
                                alt={member.name}
                                onError={(e) => { e.target.src = PLACEHOLDER; }}
                            />
                        </div>
                        <div className="board-member__info">
                            <h3 className="board-member__name">{member.name}</h3>
                            <h4 className="board-member__position">{member.position}</h4>
                            {member.bio && <p className="board-member__description">{member.bio}</p>}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ExecutiveBoard;
